import store from "@/store"
import { i18n } from "@/assets/js/vue-i18n-init"

export const state = () => ({
  list: []
})

export const getters = {
  list: (state) => state.list || [],
  sortedList(state) {
    return state.list && state.list.sort((a, b) => b.is_main - a.is_main)
  }
}

export const mutations = {
  setList(state, payload) {
    state.list = payload
  },
  createItem(state, payload) {
    // console.log('category createItem', payload);
    state.list = [...state.list, payload]
  },
  updateItem(state, payload) {
    const findIndex = state.list.findIndex((item) => item.id == payload.id)
    if (findIndex != -1) {
      state.list = [
        ...state.list.slice(0, findIndex),
        payload,
        ...state.list.slice(findIndex + 1)
      ]
    }
  },
  deleteItem(state, payload) {
    const findIndex = state.list.findIndex((item) => item.id == payload)
    if (findIndex != -1) {
      state.list = [
        ...state.list.slice(0, findIndex),
        ...state.list.slice(findIndex + 1)
      ]
    }
  }
}

export const actions = {
  async fetch({ commit }) {
    try {
      const { data } = await store.$api.get("/alerts/category/list")

      // console.log('news/category/list', data)
      commit("setList", data)

      return data || []
    } catch (error) {
      console.log(error)
      return []
    }
  },
  async fetchById(_, group_id) {
    if (!group_id) {
      return
    }
    try {
      const { data } = await store.$api.get("/alerts/category/list/" + group_id)
      return data || []
    } catch (error) {
      console.log(error)
    }
  },
  async detail(_, category_id) {
    if (!category_id) {
      return
    }
    try {
      const { data } = await store.$api.get(
        "/alerts/category/detail/" + category_id
      )
      return data || null
    } catch (error) {
      console.log(error)
    }
  },

  // // get category posts
  // async posts(_, category_id) {
  //   try {
  //     const { data } = await store.$api.get('/alerts/post/list/' + category_id)
  //
  //     return data || []
  //   } catch (e) {
  //     console.log(e)
  //   }
  // },

  createItemAction({ commit }, payload) {
    this.$api
      .post("/alerts/category/create", payload)
      .then((res) => {
        // console.log('category createItemAction res', res.data);
        commit("createItem", {
          ...res.data,
          title: JSON.parse(res.data.title)[i18n.locale]
        })
        // commit('group/updateGroupCategory', res.data, { root: true })
      })
      .catch((err) => {
        console.log(err)
      })
  },
  updateItemAction({ commit }, payload) {
    this.$api
      .put("/alerts/category/update/" + payload.id, payload.data)
      .then((res) => {
        // console.log('category updateItemAction', res);
        commit("updateItem", {
          ...res.data,
          title: JSON.parse(res.data.title)[i18n.locale]
        })
        // commit('group/updateGroupCategory', res.data, { root: true })
      })
      .catch((err) => {
        console.log("category", err)
      })
  },
  removeItemAction({ commit }, payload) {
    return this.$api
      .delete("/alerts/category/delete/" + payload)
      .then((res) => {
        // console.log(res);
        if (res.status >= 200 && res.status < 300) {
          commit("deleteItem", payload)
          return true
        }
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}
